'use strict';
//Jquery ateina is webpack config
//import $ from "jquery";

//Bootstrap
import Bootstrap from 'bootstrap';
import "bootstrap/dist/css/bootstrap.css";

//Slick slider
import SlickSlider from 'slick-slider';
import "slick-slider/slick/slick.css";

//moment
import moment from 'moment';
moment.locale('lt');

//pikaday
//import Pikaday from 'pikaday';
//import "pikaday/css/pikaday.css";

//tooltipster
//import Tooltipster from 'tooltipster';
//import "tooltipster/dist/css/tooltipster.bundle.css";

//select2
import Select2 from 'select2';
import "select2/dist/css/select2.css";

//jquery validation
import jqueryValidation from 'jquery-validation';
// Import the Lithuanian localization file
import 'jquery-validation/dist/localization/messages_lt';

//jquery ui slider
import 'jquery-ui/ui/widgets/slider';
import 'jquery-ui/themes/base/slider.css';

$.extend($.validator.messages, {
	required: "Šis laukas yra privalomas.",
	remote: "Prašome pataisyti šį lauką.",
	email: "Prašome įvesti teisingą elektroninio pašto adresą.",
	url: "Prašome įvesti teisingą URL.",
	date: "Prašome įvesti teisingą datą.",
	dateISO: "Prašome įvesti teisingą datą (pvz. 1970-01-01).",
	number: "Prašome įvesti teisingą skaičių.",
	digits: "Prašome naudoti tik skaitmenis.",
	creditcard: "Prašome įvesti teisingą kreditinės kortelės numerį.",
	equalTo: "Laukeliuose įvestos reikšmės turi sutapti.",
	extension: "Prašome įvesti reikšmę su teisingu plėtiniu.",
	maxlength: $.validator.format("Prašome įvesti ne daugiau kaip {0} simbolių."),
	minlength: $.validator.format("Prašome įvesti bent {0} simbolius."),
	rangelength: $.validator.format("Prašome įvesti reikšmes, kurių ilgis nuo {0} iki {1} simbolių."),
	range: $.validator.format("Prašome įvesti reikšmę intervale nuo {0} iki {1}."),
	max: $.validator.format("Prašome įvesti reikšmę mažesnę arba lygią {0}."),
	min: $.validator.format("Prašome įvesti reikšmę didesnę arba lygią {0}.")
});
//fancybox
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

import Cookies from "js-cookie";

//mmenu-light
import mmenuLight from 'mmenu-light';
import "mmenu-light/dist/mmenu-light.css";

$(document).ready(function () {
	(function normalizeHash() {
		var h = window.location.hash;
		if (h.charAt(1) === '!') {
			history.replaceState(null, null, '#' + h.slice(2));
		}
	})();
	if (!$("#popup_window").length) {
		addCallToActionData();
		fancybox();
//		pikaday();
//		tooltipster();
		select2init();
		validate();
		fixedHeader();
		equalHeight();
		slickSlider();
		searchToggle();
		initEuCookieSettings();
		mobileMenuInsideToggler();
		toggler();
		toggler2();
		equalHeightNew();
		dukToggle();
		themesListToggle();
		themesListToggleDuk();
		alertsControl();
		numberInputControl();
		tinyMceWorkArounds();
//		mobileSidebarToggle();
		contactsToggle();
		mobileMenu();
//		protection_zone_no();
//		protectionZonesTabs();
		searchAddressComponent();
		sidebarSticky();
//		showChristmasGreeting();
		popupMessage();
		langTabControl();
	}

});



$(window).on('load', function () {
	$("body").removeClass("preload");
	if ($(window).width() < 768) {
		mobile_overflow_tables();
	}
	attrControl();


});

function addCallToActionData() {
	const $elements = $("a, button"); // select both anchors and buttons
	if ($elements.length === 0)
		return; // no anchors or buttons found

	let counter = 1;
	$elements.each(function () {
		$(this).attr("data-call-to-action", counter++);
	});
}

function showChristmasGreeting() {
	if (!document.body.classList.contains('module-sitehomepage'))
		return;
	const showOnce = true;
	const site_name_trimmed = "eso";
	const greeting_cookie_name = `${site_name_trimmed}_christmas_greeting_2024`;
	const currentDate = new Date();
	const startDate = new Date(currentDate.getFullYear(), 11, 9); // Dec 9th
	const endDate = new Date(currentDate.getFullYear(), 12, 1); // Dec 31st

	if (!Cookies.get(greeting_cookie_name)) {

		const lang = document.documentElement.lang;
		const isMobile = window.innerWidth <= 768;
		let youtubeVideoUrl;
		if (lang === "en") {
			youtubeVideoUrl = isMobile
					? "https://www.youtube.com/embed/2uXPbCJ5_zs?autoplay=1&mute=1&rel=0&controls=0" // Mobile video for English
					: "https://www.youtube.com/embed/2uXPbCJ5_zs?autoplay=1&mute=1&rel=0&controls=0"; // Desktop video for English
		} else if (lang === "lt") {
			youtubeVideoUrl = isMobile
					? "https://www.youtube.com/embed/iEzvhphqhT8?autoplay=1&mute=1&rel=0&controls=0" // Mobile video for Lithuanian
					: "https://www.youtube.com/embed/iEzvhphqhT8?autoplay=1&mute=1&rel=0&controls=0"; // Desktop video for Lithuanian
		} else {
			youtubeVideoUrl = "https://www.youtube.com/embed/default_video_id?autoplay=1&mute=1&rel=0&controls=0";
		}
		Fancybox.show([
			{
				src: youtubeVideoUrl,
				type: "iframe",
				width: 600,
				height: 580,
				class: "christmas-popup",
			},
		], {
			infinite: false,
			Toolbar: {
				display: ["close"],
			},
			iframe: {
				preload: true,
			},
		});
		if (showOnce) {
			Cookies.set(greeting_cookie_name, 1, {expires: endDate, path: "/"});
		}
	}
}
// rodys popup visada
//function popupMessage() {
//	const popupWrapper = document.querySelector('.popup-message-wrapper');
//	if (!popupWrapper)
//		return;
//
//	const dateFrom = parseInt(popupWrapper.getAttribute('data-date-from'), 10);
//	const dateTo = parseInt(popupWrapper.getAttribute('data-date-to'), 10);
//	const currentDate = Math.floor(Date.now() / 1000);
//
//	if (currentDate < dateFrom || currentDate > dateTo) {
//		return;
//	}
//
//	const isMobile = window.matchMedia('(max-width: 768px)').matches;
//
//	const imageSelector = isMobile ? '.popup-message--mobile img' : '.popup-message--desktop img';
//	const imageElement = document.querySelector(imageSelector);
//
//	if (imageElement) {
//		const imageSrc = imageElement.getAttribute('src');
//
//		Fancybox.show([
//			{
//				src: imageSrc,
//				type: 'image',
//				class: 'popup-message',
//			}
//		], {
//			Toolbar: false
//		});
//	}
//}

// rodys pop up vel tik kai naujas langas bus atidarytas
//function popupMessage() {
//	const popupWrapper = document.querySelector('.popup-message-wrapper');
//	if (!popupWrapper) return;
//
//	const dateFrom = parseInt(popupWrapper.getAttribute('data-date-from'), 10);
//	const dateTo = parseInt(popupWrapper.getAttribute('data-date-to'), 10);
//	const currentDate = Math.floor(Date.now() / 1000);
//
//	if (currentDate < dateFrom || currentDate > dateTo) return;
//
//	// Use a session storage key that is unique per session
//	const popupShownKey = `popup-shown-${dateFrom}-${dateTo}`;
//
//	if (sessionStorage.getItem(popupShownKey)) {
//		return; // Don't show the popup again in this session
//	}
//
//	const isMobile = window.matchMedia('(max-width: 768px)').matches;
//	const imageSelector = isMobile ? '.popup-message--mobile img' : '.popup-message--desktop img';
//	const imageElement = document.querySelector(imageSelector);
//
//	if (imageElement) {
//		const imageSrc = imageElement.getAttribute('src');
//
//		Fancybox.show([
//			{
//				src: imageSrc,
//				type: 'image',
//				class: 'popup-message',
//			}
//		], {
//			Toolbar: false
//		});
//
//		// Store in sessionStorage that popup was shown
//		sessionStorage.setItem(popupShownKey, 'true');
//	}
//}

// rodys pop up vel tik kai naujas langas arba tab bus atidarytas
function popupMessage() {
	const popupWrapper = document.querySelector('.popup-message-wrapper');
	if (!popupWrapper)
		return;

	const dateFrom = parseInt(popupWrapper.getAttribute('data-date-from'), 10);
	const dateTo = parseInt(popupWrapper.getAttribute('data-date-to'), 10);
	const currentDate = Math.floor(Date.now() / 1000);

	if (currentDate < dateFrom || currentDate > dateTo)
		return;

	// Generate a unique key per tab using window.name
	if (!window.name) {
		window.name = `tab-${Date.now()}-${Math.random()}`;
	}
	const popupShownKey = `popup-shown-${window.name}-${dateFrom}-${dateTo}`;

	if (sessionStorage.getItem(popupShownKey)) {
		return; // Don't show the popup again in this tab
	}

	const isMobile = window.matchMedia('(max-width: 768px)').matches;
	const imageSelector = isMobile ? '.popup-message--mobile img' : '.popup-message--desktop img';
	const imageElement = document.querySelector(imageSelector);

	if (imageElement) {
		const imageSrc = imageElement.getAttribute('src');

		Fancybox.show([
			{
				src: imageSrc,
				type: 'image',
				class: 'popup-message',
			}
		], {
			Toolbar: false
		});

		// Store in sessionStorage that popup was shown for this specific tab
		sessionStorage.setItem(popupShownKey, 'true');
	}
}

document.querySelectorAll('.main-layout--sidebar-faqglobal .submenu__li a').forEach(link => {
	link.addEventListener('click', (event) => {
		event.preventDefault();

		const targetURL = link.getAttribute('href');

		// Check if the link has an invalid URL
		if (!targetURL || targetURL === 'javascript:void(0);') {
			// Find the closest parent element with a valid href attribute
			let closestValidParentLink = link.closest('.submenu__li')
					?.querySelector('a[href]:not([href="javascript:void(0);"])');
			// If a valid parent link is found, redirect to its URL
			if (closestValidParentLink) {
				window.location.href = closestValidParentLink.getAttribute('href');
			} else {

			}
		} else {
			// If the URL is valid, follow the original link
			window.location.href = targetURL;
		}
	});
});
document.querySelectorAll('.ul-wrapper--faqglobal a').forEach(link => {
	link.addEventListener('click', (event) => {
		event.preventDefault();
		const targetURL = link.getAttribute('href');
		console.log("Clicked URL:", targetURL);

		if (!targetURL || targetURL === 'javascript:void(0);') {
			// Traverse up the DOM to find the closest valid parent <a> with a proper href
			let closestValidParentLink = link.closest('li')
					?.querySelector('a[href]:not([href="javascript:void(0);"])');

			if (closestValidParentLink) {
				const validURL = closestValidParentLink.getAttribute('href');
				console.log("Redirecting to closest valid parent URL:", validURL);
				window.location.href = validURL;
			} else {
				console.warn("No valid parent link found.");
			}
		} else {
			// If the URL is valid, follow the original link
			console.log("Redirecting to original URL:", targetURL);
			window.location.href = targetURL;
		}
	});
});



function mobileMenu() {
	const body = $('body');
	const hamburgerToggle = $('#hamburger');
	const menuContainer = $('#mobile-menu');
	const mobileHeader = $('.mobile-header');
	const childToggler = $('#mobile-menu .ul-wrapper > ul li .child-toggle');

	hamburgerToggle.click(function () {
		body.toggleClass('mobile-menu-opened');
		menuContainer.toggleClass('active');
		mobileHeader.toggleClass('active');
	});

	childToggler.on('click', function () {
		$(this).children().toggleClass('rotate');
		$(this).next().toggle();
		$(this).prev().toggleClass("active");
	});
}

//document.addEventListener("DOMContentLoaded", () => {
//	const menuElement = document.querySelector("#menu");
//	if (menuElement) {
//		const menu = new MmenuLight(menuElement, "(max-width: 1024px)");
//
//		menu.navigation({
//			slidingSubmenus: false // Disable sliding submenus
//		});
//
//		const drawer = menu.offcanvas({
//			position: "left"
//		});
//
//		let menuOpen = false;
//		const menuToggle = document.querySelector("a[href='#menu']");
//		const mobileHeader = document.querySelector('.mobile-header');
//
//		if (menuToggle && mobileHeader) {
//			menuToggle.addEventListener("click", (evnt) => {
//				evnt.preventDefault();
//				if (!menuOpen) {
//					drawer.open();
//					mobileHeader.classList.add('active');
//				} else {
//					drawer.close();
//					mobileHeader.classList.remove('active');
//				}
//				menuOpen = !menuOpen;
//			});
//		} else {
//			console.error('Menu toggle or mobile header element not found');
//		}
//	} else {
//		console.error('Menu element not found');
//	}
//});

function mobile_overflow_tables() {
	if ($(".main-content").length) {
		$('.main-content table').each(function () {
			var element = $(this);
			// Create the wrapper element
			var scrollWrapper = $('<div />', {
				'class': 'scrollable',
				'html': '<div />' // The inner div is needed for styling
			}).insertBefore(element);
			// Store a reference to the wrapper element
			element.data('scrollWrapper', scrollWrapper);
			// Move the scrollable element inside the wrapper element
			element.appendTo(scrollWrapper.find('div'));
			// Check if the element is wider than its parent and thus needs to be scrollable
			if (element.outerWidth() > element.parent().outerWidth()) {
				element.data('scrollWrapper').addClass('has-scroll');
			}
			// When the viewport size is changed, check again if the element needs to be scrollable
			$(window).on('resize orientationchange', function () {
				if (element.outerWidth() > element.parent().outerWidth()) {
					element.data('scrollWrapper').addClass('has-scroll');
				} else {
					element.data('scrollWrapper').removeClass('has-scroll');
				}
			});
		});
	}
}

function fancybox() {
	Fancybox.bind('[data-fancybox="gallery"]', {
	});
	Fancybox.bind('[data-fancybox]', {
		autoStart: false
	});
	Fancybox.bind('[data-fancybox="iframe"]', {
		type: "iframe",
		iframe: {
			preload: false // Optionally disable iframe preloading
		},
	});
}

function equalHeightNew() {
	// Find all elements with the meta-adjust class
	var metaElements = $('.meta-adjust');

	// Find the maximum height among the meta elements
	var maxHeight = 0;
	metaElements.each(function () {
		var elementHeight = $(this).height();
		if (elementHeight > maxHeight) {
			maxHeight = elementHeight;
		}
	});

	// Set the maximum height to all meta elements
	metaElements.height(maxHeight);
}
//With todays date placeholder
//function pikaday() {
//	const datePickerElements = document.querySelectorAll('.datepicker');
//	datePickerElements.forEach(datePickerElement => {
//		const today = new Date();
//		const formattedDate = moment(today).format('YYYY-MM-DD');
//
//		datePickerElement.value = formattedDate;
//
//		new Pikaday({
//			field: datePickerElement,
//			format: 'YYYY-MM-DD',
//			showDaysInNextAndPreviousMonths: true,
//			toString(date) {
//				return moment(date).format('YYYY-MM-DD');
//			},
//			parse(dateString) {
//				return moment(dateString, 'YYYY-MM-DD').toDate();
//			},
//			i18n: {
//				previousMonth: 'Ankstesnis mėnuo',
//				nextMonth: 'Kitas mėnuo',
//				months: moment.localeData().months(),
//				weekdays: moment.localeData().weekdays(),
//				weekdaysShort: moment.localeData().weekdaysShort()
//			}
//		});
//	});
//}

function tooltipster() {
	if ($(".tooltip").length) {
		$('.tooltip').tooltipster({
			delay: 0,
			position: 'right',
			maxWidth: 236,
		});
	}
}

function select2init() {
	$("select").select2({
		"minimumResultsForSearch": Infinity
	});

	// use this class if placeholder is needed. 
	// Translation added as data attribute: <select data-placeholder="{'choise_value'|t}">
	// Also, first option in select element has to be empty: <option value=""></option>
	$("select.select2_with_dynamic_placeholder").select2({
		"minimumResultsForSearch": Infinity,
		placeholder: function () {
			$(this).data('placeholder');
		}
	});
}

var submitted_form = null;
function validate() {
	var options = {
		highlight: function (element, errorClass, validClass) {
			if ($(element).closest(".form__item").length) {
				$(element).closest(".form__item").removeClass(validClass).addClass(errorClass);
			}
		},
		unhighlight: function (element, errorClass, validClass) {
			if ($(element).closest(".form__item").length) {
				$(element).closest(".form__item").removeClass(errorClass).addClass(validClass);
			}
		},
		errorPlacement: function (error, element) {
			$(element).closest(".form__item").find('.error-message').append(error);
		},
		ignore: ":hidden:not(select)", // Ignore hidden fields except select
		onkeyup: false, // Disable validation on keyup events
		onfocusout: function (element) {
			$(element).valid(); // Validate when element loses focus
		}
	};

	function setupFormValidation(formSelector) {
		if ($(formSelector).length) {
			$(formSelector).validate(options);
			let userInitiatedChange = false;

			// Initialize Select2 without search bar
			$(formSelector + ' select').select2({
				minimumResultsForSearch: Infinity // Disable search bar
			}).on('select2:select', function () {
				userInitiatedChange = true;
			});

			$(formSelector + ' select').change(function () {
				if (userInitiatedChange) {
					$(this).valid();
					userInitiatedChange = false; // Reset flag
				}
			});

			$(formSelector + ' input[type="file"]').change(function () {
				$(this).valid();
			});
		}
	}

	setupFormValidation("#forms_form");
	setupFormValidation("#letter_form");
	setupFormValidation("#poll_form");
	setupFormValidation("#subscription_form");
	setupFormValidation("#poll_widget");
	setupFormValidation("#sitelogin_widget");
	setupFormValidation("#duk_form");
	setupFormValidation(".comment-form");
	setupFormValidation("#sitelogin_form");
	setupFormValidation("#faq_form");
	setupFormValidation("#subscription_form_index");
	setupFormValidation("#remind_pass_form");
	setupFormValidation("#custom_validate");

	jQuery.validator.addMethod("date", function (date, element) {
		return this.optional(element) || date.match(/^\d{4}-((0\d)|(1[012]))-(([012]\d)|3[01])$/);
	}, "Prašome įvesti datą formatu YYYY-MM-DD");

	jQuery.validator.addMethod('phone', function (value, element) {
		return this.optional(element) || /^\+370\d{8}$/.test(value);
	}, "Prašome įvesti telefono numerį formatu +370XXXXXXXX");

	var options_excavation = {
		highlight: function (element, errorClass, validClass) {
			if ($(element).closest(".form__item").length) {
				$(element).closest(".form__item").removeClass(validClass).addClass(errorClass);
			}
		},
		unhighlight: function (element, errorClass, validClass) {
			if ($(element).closest(".form__item").length) {
				$(element).closest(".form__item").removeClass(errorClass).addClass(validClass);
			}
		},
		rules: {
			legal_manager_phone: {
				phone: true
			},
			individual_phone: {
				phone: true
			}
		}
	};

	if ($(".excavationwork_form").length) {
		$(".excavationwork_form").validate(options_excavation);
	}
}



function fixedHeader() {
	var $header = $('.header-container');
	var $mobileHeader = $('.mobile-header');
	var scrollDirection = 'down';

	function handleScroll() {
		var scrollTop = $(window).scrollTop();
		var threshold = 100;

		if (scrollTop > threshold) {
			$header.addClass('header-scrolled');
			$mobileHeader.addClass('mobile-header-scrolled');
		} else {
			$header.removeClass('header-scrolled');
			$mobileHeader.removeClass('mobile-header-scrolled');
		}

		if (scrollTop > threshold * 3) {
			if (scrollDirection === 'down') {
				$header.addClass('scroll-up');
				$mobileHeader.addClass('scroll-up');
				scrollDirection = 'up';
			}
		} else {
			if (scrollDirection === 'up') {
				$header.removeClass('scroll-up');
				$mobileHeader.removeClass('scroll-up');
				scrollDirection = 'down';
			}
		}
	}

	// Attach scroll event listener
	$(window).on('scroll', handleScroll);

	// Call the scroll handler once to initialize the header state
	handleScroll();
}

function equalHeight() {
	window.addEventListener('load', function () {
		if (isDesktop()) {
			setEqualHeight();
			window.addEventListener('resize', setEqualHeight);
		}
	});

	function isDesktop() {
		// Define the screen width breakpoint for desktop devices
		var desktopWidth = 1024;

		// Check if the current screen width is greater than or equal to the desktop breakpoint
		return window.innerWidth >= desktopWidth;
	}

	function setEqualHeight() {
		var elements = document.getElementsByClassName('equalheight');
		var maxHeight = 0;

		// Reset the heights
		Array.from(elements).forEach(function (element) {
			element.style.height = 'auto';
		});

		// Find the maximum height
		Array.from(elements).forEach(function (element) {
			var height = element.offsetHeight;
			if (height > maxHeight) {
				maxHeight = height;
			}
		});

		// Set the maximum height to all elements
		Array.from(elements).forEach(function (element) {
			element.style.height = maxHeight + 'px';
		});
	}
}

function slickSlider() {
	if ($(window).width() < 1024) {
		let $slickSlider = $(".s--contacts .top--slider, .protectionzones .top--slider");
		// Count the number of items (slides) inside the slider
		let itemCount = $slickSlider.children().length;

		// Only initialize the slider if there are more than 2 items
		if (itemCount > 2) {
			if (!$slickSlider.hasClass('slick-initialized')) {
				$slickSlider.on('init', function (event, slick) {
					$slickSlider.closest('.s--contacts').addClass('slick-initialized');
				});

				$slickSlider.slick({
					prevArrow: '<em class="icon icon-chevron-left previous"></em>',
					nextArrow: '<em class="icon icon-chevron-right next"></em>',
					infinite: false,
					dots: false,
					fade: false,
					speed: 250,
					arrows: true,
					slidesToShow: 2, // Default to 2 slides for mobile devices
					adaptiveHeight: false,
					responsive: [
						{
							breakpoint: 1024,
							settings: {
								slidesToShow: 2
							}
						},
						{
							breakpoint: 768,
							settings: {
								slidesToShow: 2
							}
						},
						{
							breakpoint: 576,
							settings: {
								slidesToShow: 2
							}
						},
						{
							breakpoint: 475,
							settings: {
								slidesToShow: 2
							}
						},
					],
				});
			}
		}
	}


	if ($(window).width() < 768) {
		if ($(".cookies_slider").length > 0) {
			var $slider = $('.cookies_slider');
			$slider.slick({
				dots: true,
				arrows: false,
				infinite: false,
				slidesToShow: 1,
			});
		}
	}
	if ($(".news__slider").length > 0) {
		var $slider = $('.news__slider');
		$slider.on('init', function (event, slick) {
			var slideCount = slick.slideCount;
			var slidesToShow = slick.options.slidesToShow;
			if (slideCount > slidesToShow) {
				$slider.addClass('activated');
			} else {
				$slider.removeClass('activated');
			}
		});

		$slider.slick({
			slidesToShow: 3,
			slidesToScroll: 1,
			arrows: false,

			responsive: [{
					breakpoint: 768,
					settings: {
						slidesToShow: 2,
					}
				},
				{
					breakpoint: 475,
					settings: {
						slidesToShow: 1,
					}
				}
			]
		});
		if ($slider.hasClass('activated')) {

		} else {
			$('.slider-nav').remove();
		}

		if ($slider.hasClass('activated')) {
			$('.news .slider-nav .prev').click(function () {
				$slider.slick('slickPrev');
			});
		}

		if ($slider.hasClass('activated')) {
			$('.news .slider-nav .next').click(function () {
				$slider.slick('slickNext');
			});
		}
	}


	if ($(".slideshow-slider").length > 0) {
		$(".slideshow-slider").slick({
			autoplay: true,
			autoplaySpeed: 5000,
			prevArrow: '<em class="icon icon-chevron-left previous"></em>',
			nextArrow: '<em class="icon icon-chevron-right next"></em>',
			infinite: true,
			dots: true,
			fade: true,
			arrows: false,
			slidesToShow: 1,
			adaptiveHeight: false,
			dotsClass: "slick-dots container-fluid global_container",
			responsive: [
				{
					breakpoint: 1024,
					settings: {
					}
				},
				{
					breakpoint: 768,
				},
				{
					breakpoint: 576,
				},
				{
					breakpoint: 475,
				}],
		});
	}

	if ($(".important-links-slider").length > 0) {
		$(".important-links-slider").slick({
			prevArrow: '<button class="mygtukas mygtukas--arrow mygtukas--arrow-left" aria-label="previous"></button>',
			nextArrow: '<button class="mygtukas mygtukas--arrow mygtukas--arrow-right" aria-label="next"></button>',
			dots: false,
			arrows: true,
			infinite: false,
			slidesToShow: 4,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 3,
					}
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 3,
						dots: true
					}
				},
				{
					breakpoint: 576,
					settings: {
						slidesToShow: 2,
						dots: true
					}
				},
				{
					breakpoint: 475,
					settings: {
						slidesToShow: 2,
						dots: true
					}
				}],
		});
	}
}

function searchToggle() {
	let body = $('body');
	let btn = $('.search-toggle');
	let formWrapper = $('.top-search-wr');
	let formWrapperFull = $('.top-search-wr .full-wrapper');
	let inputField = $('.mw-wrap form input[type="text"]');

	btn.click(function () {
		formWrapper.toggleClass("active");
		body.toggleClass("overflow-hidden");

		if (formWrapper.hasClass("active")) {
			inputField.focus();
		}
	});

	// Handle clicks outside the formWrapper
	$(document).mouseup(function (e) {
		// If the clicked element is not a child of formWrapper
		if (!formWrapperFull.is(e.target) && formWrapperFull.has(e.target).length === 0) {
			formWrapper.removeClass("active");
			body.removeClass("overflow-hidden");
		}
	});
	// Handle ESC key press
	$(document).keyup(function (e) {
		// If ESC key is pressed and the formWrapper is active
		if (e.keyCode === 27 && formWrapper.hasClass("active")) {
			formWrapper.removeClass("active");
			body.removeClass("overflow-hidden");
		}
	});
}
;

function initEuCookieSettings() {
	$('a.cookies-settings').click(function () {
		$('body').addClass('cookies-not-activated');
		$('#eucookie_dialog').removeClass('activated');

		setTimeout(function () {
			const container = document.querySelector('.ck_container');
			if (container) {
				container.setAttribute('tabindex', '-1');
				container.focus();
			}
		}, 50);
	});
}


function mobileMenuInsideToggler() {
	var menuBottom = $('.mobile_menu_parent .menu_bottom > ul > li > a')

	menuBottom.click(function () {
		$(this).next('ul.menu-list').toggle();
	});
}

function toggler() {
	const submenuLinks = document.querySelectorAll(".main-layout--sidebar .submenu__a.has-childs.active");

	submenuLinks.forEach((link) => {
		const icon = link.querySelector(".icon");
		if (icon) {
			icon.addEventListener("click", function (event) {
				event.preventDefault();

				link.classList.toggle("active");

				const submenuList = link.nextElementSibling;

				if (submenuList) {
					submenuList.classList.toggle("active");
				}

				const parentSubmenuLi = link.closest(".submenu__li");
				if (parentSubmenuLi) {
					parentSubmenuLi.classList.toggle("opened");
				}
			});
		}
	});
}

function toggler2() {
	const submenu2Links = document.querySelectorAll(".main-layout--sidebar .submenu2__a.has-childs.active");

	submenu2Links.forEach((link) => {
		const icon = link.querySelector(".icon");

		if (icon) {
			icon.addEventListener("click", function (event) {
				event.preventDefault();
				link.classList.toggle("active");

				const submenu2List = link.nextElementSibling;
				if (submenu2List)
					submenu2List.classList.toggle("active");

				const parentSubmenu2Li = link.closest(".submenu2__li");
				if (parentSubmenu2Li)
					parentSubmenu2Li.classList.toggle("opened");
			});
		}
	});
}



function dukToggle() {
	var $list = $('.duk__list');
	var items = $list.find('.duk__item');
	var isFaqList = $list.hasClass('duk__list--faq');
	var isWideScreen = window.innerWidth >= 1024;

	// If you ever need to re-run this on resize, uncomment the next line to clear old wrappers:
	// $list.find('.wrapper').children().unwrap();

	var firstWrapper, secondWrapper, thirdWrapper;

	if (isFaqList && isWideScreen) {
		var third = Math.ceil(items.length / 3);
		var first3 = items.slice(0, third);
		var second3 = items.slice(third, third * 2);
		var last3 = items.slice(third * 2);

		firstWrapper = $('<div class="wrapper"></div>');
		secondWrapper = $('<div class="wrapper"></div>');
		thirdWrapper = $('<div class="wrapper"></div>');

		first3.wrapAll(firstWrapper);
		second3.wrapAll(secondWrapper);
		last3.wrapAll(thirdWrapper);
	} else {
		var half = Math.ceil(items.length / 2);
		var first2 = items.slice(0, half);
		var second2 = items.slice(half);

		firstWrapper = $('<div class="wrapper"></div>');
		secondWrapper = $('<div class="wrapper"></div>');

		first2.wrapAll(firstWrapper);
		second2.wrapAll(secondWrapper);
	}

	// Ensure every item and its toggle button start aria-expanded="false"
	items
			.attr('aria-expanded', 'false')
			.find('button')
			.attr('aria-expanded', 'false');

	// Click handler for toggling
	items
			.filter('.toggleable')
			.find('.question-wrapper')
			.off('click')
			.on('click', function () {
				var $item = $(this).closest('.duk__item');
				var isActive = $item.hasClass('active');

				// Close all items
				items
						.removeClass('active')
						.attr('aria-expanded', 'false')
						.find('button')
						.attr('aria-expanded', 'false');

				if (!isActive) {
					// Open clicked item
					$item
							.addClass('active')
							.attr('aria-expanded', 'true')
							.find('button')
							.attr('aria-expanded', 'true');

					scrollIntoView($item.get(0));

					// Update URL hash & send analytics
					var itemId = $item.attr('id');
					if (itemId) {
						history.replaceState(null, null, '#' + itemId);
						if (typeof gtag === 'function') {
							gtag('event', 'page_view', {
								hash: itemId,
								page_location: window.location.href
							});
						}
					}
				} else {
					// Clicking an open item just clears the hash
					history.replaceState(null, null, ' ');
				}
			});

	// On page-load, open item if URL has a hash
	var hash = window.location.hash.substring(1);
	if (hash) {
		var $active = $('#' + hash);
		if ($active.length) {
			items
					.removeClass('active')
					.attr('aria-expanded', 'false')
					.find('button')
					.attr('aria-expanded', 'false');

			$active
					.addClass('active')
					.attr('aria-expanded', 'true')
					.find('button')
					.attr('aria-expanded', 'true');

			scrollIntoView($active.get(0));

			if (typeof gtag === 'function') {
				gtag('event', 'page_view', {
					hash: hash,
					page_location: window.location.href
				});
			}
		}
	}

	function scrollIntoView(element) {
		var pos = element.getBoundingClientRect().top + window.scrollY;
		var off = (window.innerWidth >= 1024 ? 16 : 100);
		var final = pos - off;
		window.scrollTo({top: final, behavior: 'smooth'});
	}
}



function themesListToggle() {
	var $categories = $('.themeslist__item[id^="c"]:not([id*="-t"])'); // parent categories
	var $topics = $('.themeslist__item[id*="-t"]');             // child topics
	var $allItems = $categories.add($topics);

	// Initialize: collapse everything
	$allItems
			.removeClass('active')
			.attr('aria-expanded', 'false')
			.find('button')
			.attr('aria-expanded', 'false');

	// Click handler
	document.querySelectorAll('.themeslist__item.toggleable .question-wrapper')
			.forEach(function (wrapper) {
				wrapper.addEventListener('click', function (e) {
					var item = this.parentElement;
					var id = item.id;
					var isCategory = id.indexOf('-t') === -1;
					var isActive = item.classList.contains('active');

					// Always collapse all first
					$allItems
							.removeClass('active')
							.attr('aria-expanded', 'false')
							.find('button')
							.attr('aria-expanded', 'false');

					if (isCategory) {
						if (!isActive) {
							// Open this category
							var $item = $(item);
							$item
									.addClass('active')
									.attr('aria-expanded', 'true')
									.find('button')
									.attr('aria-expanded', 'true');
							scrollIntoView(item);
							updateHashAndAnalytics(id);
						} else {
							clearHash();
						}

					} else {
						// It's a topic: ensure its parent category is open
						var parentId = id.split('-t')[0];
						var parentEl = document.getElementById(parentId);
						if (parentEl) {
							var $parent = $(parentEl);
							$parent
									.addClass('active')
									.attr('aria-expanded', 'true')
									.find('button')
									.attr('aria-expanded', 'true');
						}

						if (!isActive) {
							// Open this topic
							var $item = $(item);
							$item
									.addClass('active')
									.attr('aria-expanded', 'true')
									.find('button')
									.attr('aria-expanded', 'true');
							scrollIntoView(item);
							updateHashAndAnalytics(id);
						} else {
							// Closing topic: fall back to parent category in hash
							updateHashAndAnalytics(parentId);
						}
					}

					e.stopPropagation();
				});
			});

	// On load: open based on URL hash
	var hash = window.location.hash.substring(1);
	if (hash) {
		var parts = hash.split('-t');
		var catId = parts[0];
		var topicId = parts.length > 1 ? hash : null;
		var catEl = document.getElementById(catId);

		if (catEl) {
			// Collapse all
			$allItems
					.removeClass('active')
					.attr('aria-expanded', 'false')
					.find('button')
					.attr('aria-expanded', 'false');

			// Open category
			var $cat = $(catEl);
			$cat
					.addClass('active')
					.attr('aria-expanded', 'true')
					.find('button')
					.attr('aria-expanded', 'true');
			scrollIntoView(catEl);
			sendGtag(catId);

			// If there's a topic, open it too
			if (topicId) {
				var topicEl = document.getElementById(topicId);
				if (topicEl) {
					var $topic = $(topicEl);
					$topic
							.addClass('active')
							.attr('aria-expanded', 'true')
							.find('button')
							.attr('aria-expanded', 'true');
					scrollIntoView(topicEl);
					sendGtag(topicId);
				}
			}
		}
	}

	// -- helper functions --

	function scrollIntoView(el) {
		var pos = el.getBoundingClientRect().top + window.scrollY;
		var offset = window.innerWidth >= 1024 ? 16 : 100;
		window.scrollTo({top: pos - offset, behavior: 'smooth'});
	}

	function updateHashAndAnalytics(id) {
		history.replaceState(null, null, '#' + id);
		sendGtag(id);
	}

	function clearHash() {
		history.replaceState(null, null, ' ');
	}

	function sendGtag(hash) {
		if (typeof gtag === 'function') {
			gtag('event', 'page_view', {
				hash: hash,
				page_location: window.location.href
			});
		}
	}
}


function themesListToggleDuk() {
	const $categories = $('.themeslist2__item[id^="ffaq"]:not([id*="-t"])');
	const $topics = $('.themeslist2__item[id*="-t"]');
	const $allItems = $categories.add($topics);
	const wrappers = document.querySelectorAll('.themeslist2__item.toggleable .question-wrapper');

	// 1) Initialize
	$allItems
			.removeClass('active')
			.attr('aria-expanded', 'false');

	// 2) Click handler
	wrappers.forEach(wrapper => {
		wrapper.addEventListener('click', e => {
			const item = wrapper.closest('.themeslist2__item');
			const id = item.id;
			const isCategory = !id.includes('-t');
			const isOpen = item.classList.contains('active');

			// collapse everything
			$allItems
					.removeClass('active')
					.attr('aria-expanded', 'false');

			if (isCategory) {
				if (!isOpen) {
					openItem(item);
				} else {
					closeItem(item);
				}
			} else {
				// topic: keep parent category open
				const catId = id.split('-t')[0];
				const catEl = document.getElementById(catId);
				if (catEl) {
					$(catEl)
							.addClass('active')
							.attr('aria-expanded', 'true');
				}

				if (!isOpen) {
					openItem(item);
				} else {
					closeItem(item, /* fallbackHash= */ catId);
				}
			}

			e.stopPropagation();
		});
	});

	// 3) Deep-link on load
	const hash = window.location.hash.slice(1);
	if (hash) {
		const el = document.getElementById(hash);
		if (el) {
			$allItems
					.removeClass('active')
					.attr('aria-expanded', 'false');

			$(el)
					.addClass('active')
					.attr('aria-expanded', 'true');
			scrollIntoView(el);
			sendGtag(hash);

			// if it's a topic, expand its parent too
			if (hash.includes('-t')) {
				const parentId = hash.split('-t')[0];
				const parentEl = document.getElementById(parentId);
				if (parentEl) {
					$(parentEl)
							.addClass('active')
							.attr('aria-expanded', 'true');
				}
			}
		}
	}

	// — helpers —

	function openItem(el) {
		$(el)
				.addClass('active')
				.attr('aria-expanded', 'true');
		updateHash(el.id);
		scrollIntoView(el);
	}

	function closeItem(el, fallbackHash = '') {
		$(el)
				.removeClass('active')
				.attr('aria-expanded', 'false');
		if (fallbackHash)
			updateHash(fallbackHash);
		else
			clearHash();
	}

	function updateHash(id) {
		history.replaceState(null, null, `#${id}`);
		sendGtag(id);
	}

	function clearHash() {
		history.replaceState(null, null, ' ');
	}

	function sendGtag(hash) {
		if (typeof gtag === 'function') {
			gtag('event', 'page_view', {
				hash,
				page_location: window.location.href
			});
		}
	}

	function scrollIntoView(el) {
		const top = el.getBoundingClientRect().top + window.scrollY;
		const offset = window.innerWidth >= 1024 ? 16 : 100;
		window.scrollTo({top: top - offset, behavior: 'smooth'});
	}
}



window.processThemesListToggle = function () {
	var categoryItems = $('.themeslist1__item[id^="c"]'); // Categories
	var questionWrappers = document.querySelectorAll('.themeslist1__item.toggleable .question-wrapper');

	questionWrappers.forEach(function (questionWrapper) {
		questionWrapper.addEventListener('click', function (event) {
			var parentItem = this.parentElement;
			var isActive = parentItem.classList.contains('active');

			// Toggle the category item
			categoryItems.removeClass('active');
			if (!isActive) {
				parentItem.classList.add('active');
				scrollIntoView(parentItem);
			}

			event.stopPropagation(); // Prevent the event from bubbling up
		});
	});

	function scrollIntoView(element) {
		var elementPosition = element.getBoundingClientRect().top + window.scrollY;
		var offsetPosition = elementPosition - 20;

		window.scrollTo({
			top: offsetPosition,
			behavior: 'smooth'
		});
	}
};


function alertsControl() {
	if ($(".s--message").length) {
		let messageClose = $(".s--message .message .close");
		let imgneditor = $(".s--imgneditor");
		messageClose.click(function () {
			$(this).closest('.s--message').remove();
			imgneditor.removeClass("has-message-above");
		})
	}
}

function numberInputControl() {
	const minusButtons = document.querySelectorAll('.minus');
	const plusButtons = document.querySelectorAll('.plus');

	minusButtons.forEach(minusButton => {
		minusButton.addEventListener('click', function () {
			const numberInput = this.nextElementSibling;
			if (!numberInput.hasAttribute('disabled')) {
				let currentValue = parseInt(numberInput.value) || 0;
				if (currentValue > 0) {
					numberInput.value = currentValue - 1;
				}
			}
		});
	});

	plusButtons.forEach(plusButton => {
		plusButton.addEventListener('click', function () {
			const numberInput = this.previousElementSibling;
			if (!numberInput.hasAttribute('disabled')) {
				let currentValue = parseInt(numberInput.value) || 0;
				numberInput.value = currentValue + 1;
			}
		});
	});
}

function tinyMceWorkArounds() {
	$('.atsisiusti-dokumenta').each(function () {
		let anchor = $(this).find('a');
		if (anchor.length > 0) {
			let href = anchor.attr('href');
			if (anchor.attr('target') === '_blank') {
				$(this).attr('onClick', 'window.open("' + href + '", "_blank");');
			} else {
				$(this).attr('onClick', 'window.location.href="' + href + '";');
			}
		}
	});
}

//function mobileSidebarToggle() {
//	var mainToggler = document.querySelector('.mobile-sidebar-menu-wrapper .main-toggler');
//
//	if (!mainToggler) return;
//
//	mainToggler.addEventListener('click', function () {
//		var sidebarMenuWrapper = document.querySelector('.mobile-sidebar-menu-wrapper');
//		sidebarMenuWrapper.classList.toggle('active');
//
//		if (mainToggler.classList.contains('icon-plus')) {
//			mainToggler.classList.remove('icon-plus');
//			mainToggler.classList.add('icon-minus');
//		} else {
//			mainToggler.classList.remove('icon-minus');
//			mainToggler.classList.add('icon-plus');
//		}
//	});
//
//}
function contactsToggle() {
	// — ARIA Helpers —
	function collapseToggles(toggles) {
		toggles.forEach(toggle => {
			toggle.classList.remove('active');
			toggle.setAttribute('aria-expanded', 'false');
		});
	}

	function collapseBlocks(blocks) {
		blocks.forEach(block => {
			block.classList.remove('active');
			block.setAttribute('aria-hidden', 'true');
		});
	}

	function expandToggle(toggle) {
		toggle.classList.add('active');
		toggle.setAttribute('aria-expanded', 'true');
	}

	function expandBlock(block) {
		block.classList.add('active');
		block.setAttribute('aria-hidden', 'false');
	}

	function resetSubLevel(parentBlock) {
		const subToggles = Array.from(parentBlock.querySelectorAll('.contacts__toggle--sub'));
		const subBlocks = Array.from(parentBlock.querySelectorAll('.contacts__block'));
		collapseToggles(subToggles);
		collapseBlocks(subBlocks);
		if (subToggles[0])
			expandToggle(subToggles[0]);
		if (subBlocks[0])
			expandBlock(subBlocks[0]);
	}

	// — Keyboard support only (no role/tabindex/aria-expanded from JS) —
	document.querySelectorAll('.contacts__toggle').forEach(toggle => {
		toggle.addEventListener('keydown', e => {
			if (e.key === 'Enter' || e.key === ' ') {
				e.preventDefault();
				toggle.click();
			}
		});
	});

	// — On load: collapse every block that isn't already .active in your HTML —
	document.querySelectorAll('.contacts__block').forEach(block => {
		block.setAttribute(
				'aria-hidden',
				block.classList.contains('active') ? 'false' : 'true'
				);
	});

	// — Top‐level toggles —
	document
			.querySelectorAll('.contacts__toggle:not(.contacts__toggle--sub)')
			.forEach(toggle => {
				toggle.addEventListener('click', () => {
					const container = toggle.closest('.contacts');
					const siblingToggles = Array.from(
							container.querySelectorAll('.contacts__toggle:not(.contacts__toggle--sub)')
							);
					const siblingBlocks = Array.from(container.querySelectorAll('.contacts__block'));
					const targetId = toggle.id;
					const activeBlock = container.querySelector(
							`.contacts__block[data-id="${targetId}"]`
							);

					// collapse all top‐level
					collapseToggles(siblingToggles);
					collapseBlocks(siblingBlocks);

					// expand this one
					expandToggle(toggle);
					if (activeBlock) {
						expandBlock(activeBlock);
						resetSubLevel(activeBlock);
					}
				});
			});

	// — Sub‐level toggles (delegated) —
	document.addEventListener('click', event => {
		if (!event.target.classList.contains('contacts__toggle--sub'))
			return;
		const subToggle = event.target;
		const parentBlock = subToggle.closest('.contacts__block');
		const siblingToggles = Array.from(
				parentBlock.querySelectorAll('.contacts__toggle--sub')
				);
		const siblingBlocks = Array.from(parentBlock.querySelectorAll('.contacts__block'));
		const targetId = subToggle.id;
		const activeSubBlock = parentBlock.querySelector(
				`.contacts__block[data-id="${targetId}"]`
				);

		collapseToggles(siblingToggles);
		collapseBlocks(siblingBlocks);

		expandToggle(subToggle);
		if (activeSubBlock)
			expandBlock(activeSubBlock);

		event.stopPropagation();
	});
}


function ngSlideToggle(e) {
	$(e.target).parent().toggleClass('js-expanded');
	$(e.target).next('.faq-q__body').slideToggle(150);
}
;

//function protection_zone_no() {
//	if (document.querySelectorAll('#protection-zone-no').length > 0) {
//		var mask = [/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
//		var inputs = document.querySelectorAll('#protection-zone-no');
//		var l = inputs.length;
//		for (var i = 0; i < l; i++) {
//			var maskedInputController = maskInput({
//				inputElement: inputs[i],
//				mask: mask,
//				guide: false,
//				showMask: false
//			});
//		}
//	}
//};

/**
 * Creates new hashchange event callback
 *
 * @param {Object} arg = {callback: callback_function, rule: {RegExp|String}, bubbling: {true|false}}
 * @param {Object} hashControllerObj
 * @returns {null|hashCallBack}
 */
function hashCallBack(arg, hashControllerObj) {
	this.callback;
	this.bubbling = false;
	this.rule = null;
	this.hashObj = hashControllerObj;
	this.lock = false;
	var self = this;

	/**
	 * Constructor
	 * @param {Object} arg
	 * @returns {hashCallBack|null}
	 */
	this.init = function (arg) {
		if (this.setCallback(arg.callback)) {
			if (arg.bubbling) {
				this.bubbling = arg.bubbling;
			}
			this.setRule(arg.rule);
			window.addEventListener("hashchange", self.call, this.bubbling);
			return this;
		}
		return null;
	};

	/**
	 *
	 * @param {Event} e
	 * @returns {null|String} callback response | null
	 */
	this.call = function (e) {
		if (self.checkRule(self.hashObj.get()) && !self.lock) {
			return self.callback(e, self);
		}
		return null;
	};

	/**
	 * Check if event callback will be executed
	 * @param {String} str hash string to test rule
	 * @returns {Boolean}
	 */
	this.checkRule = function (str) {
		return (!this.rule || this.rule.test(str));
	};

	/**
	 * Set event callback execution rule.
	 * @param {String|RegExp} rule
	 */
	this.setRule = function (rule) {
		if (typeof (rule) !== 'undefined' && rule != '') {
			if (typeof (rule) !== 'object') {
				this.rule = new RegExp(rule);
			} else {
				this.rule = rule;
			}
		}
	};

	/**
	 *
	 * @param {String|Function} callback
	 * @returns {Boolean} Return true if callback is valid function, otherwise - false
	 */
	this.setCallback = function (callback) {
		if (typeof (callback) === 'string') {
			if (typeof (window[callback]) === 'function') {
				this.callback = window[callback];
				return true;
			}
			return false;
		} else if (typeof (callback) === 'function') {
			this.callback = callback;
			return true;
		}
		return false;
	};

	return this.init(arg);
}
;

/**
 * hashChange event controller
 * @example register hashController.register({
 *			callback: (function(){} | "functioNname" | object.method),
 *			rule: (new RegExp("^[a-z]+$", "i") | "^[a-z]+$"),
 *			bubbling: false
 * });
 * @type hashController
 */
var hashController = new function () {

	this.db = new Array();
	var self = this;
	/**
	 *
	 * @param {Object} callbackParams {
	 *			callback: (function(){} | "functioNname" | object.method),
	 *			rule: (new RegExp("^[a-z]+$", "i") | "^[a-z]+$"),
	 *			bubbling: false
	 * }
	 * @returns {hashCallBack}
	 */
	this.register = function (callbackParams) {
		var cb = new hashCallBack(callbackParams, this);
		self.db.push(cb);
		return cb;
	};

	/**
	 *
	 * @returns {string} hash string without '#'
	 */
	this.get = function () {
		return location.hash.replace(/^#/, '');
	};

	this.set = function (hash) {
		location.hash = hash;
	};

	this.clear = function () {
		//this.set(''); // deleted, because jumps to top page
		history.replaceState({}, document.title, location.pathname);
	};

	this.replace = function (hash) {
		history.replaceState({}, document.title, location.pathname + '#' + hash);
	};

	this.trigger = function () {
		for (var i = 0; i < self.db.length; i++) {
			if (document.createEvent) {
				var e = document.createEvent("Event");
				e.initEvent("hashchange", true, true);//,window,0,0,0,0,0,false,false,false,false,0,null);
			} else {
				var e = new Event('hashchange', {});
			}
			self.db[i].call(e);
		}
	};

};
/**
 * Alias for hashController
 * @type @exp;hashController
 */
var hc = hashController;

/**
 * @example hc.register({callback: function(e, h){
 *			console.log(h.get());
 *		}});
 *
 *		hc.set('raudona');
 */

$(document).ready(function () {
	hc.trigger();
});

function protectionZonesRoute() {
	this.hcb;
	this.zoneTab = '';

	var self = this;

	this.getElement = function () {
		if (this.zoneTab == '') {
			this.zoneTab = 'find';
		}

		if ($('#' + this.zoneTab)) {
			return $('#' + this.zoneTab);
		}
		return false;
	};

	this.init = function () {
		var $q = this.getElement();
		if ($q) {
			if (this.zoneTab == 'find') {
				$('#search').show();
				$('#list').hide();
			} else {
				$('#search').hide();
				$('#list').show();
			}
		}
	};

	this.route = function (e, hcb) {
		this.hcb = hcb;

		var parts = this.hcb.hashObj.get().replace(/^\!/, '').split('/');
		this.zoneTab = parts[0];

		this.init();
	};
}
;

function protectionZonesTabs() {
	var previousActiveTabIndex = 0;

	var r = new protectionZonesRoute();

	hc.register({
		callback: function (e, hcb) {
			r.route(e, hcb);
		},
		rule: new RegExp("^\[a-z]*$"),
	});

	if (window.location.hash != '' && $(window.location.hash).length > 0) {
		previousActiveTabIndex = $(window.location.hash).data("tab-index");
		$('.tab-switcher.active').removeClass('active');
		$('.tab-switcher[data-tab-index=' + previousActiveTabIndex + ']').addClass('active');
		$(".tab-container").hide();
		$(window.location.hash).show();
	}



	$(".tab-switcher").on('click', function (event) {
		if (event.type === "click") {

			var newHash = '#' + $(this).attr('id');
			if (newHash == hc.get()) {
				hc.clear();
			} else {
				location.hash = '#' + $(this).attr('id');
			}

			$('.tab-switcher.active').removeClass('active');
			$(this).addClass('active');
			var tabClicked = $(this).data("tab-index");

			if (tabClicked != previousActiveTabIndex) {
				$("#tabs-container .tab-container").each(function () {
					if ($(this).data("tab-index") == tabClicked) {
						$(".tab-container").hide();
						$(this).show();
						previousActiveTabIndex = $(this).data("tab-index");
						return;
					}
				});
			}
		}
	});
}
;

function searchAddressComponent() {
	if ($('.address-search-component-holder').length > 0) {
		$('body').on('click', '.show-address-inputs', function () {
			var activeEl = $('.select2-container--open').parents('.address-search-component-holder');
			activeEl.find('.input-wrapper:not(.custom-address),.hide-address-inputs').show();
			activeEl.find('.type_b').hide();
			activeEl.find('select.select2').select2('close');
		});
		$('.address-search-component-holder select.select2').on('select2:select', function (e) {
			var activeEl = $(this).parents('.address-search-component-holder');
			activeEl.find('.input-wrapper:not(.custom-address),.hide-address-inputs').show();
			activeEl.find('.type_b').hide();
			$(this).select2('close');
		});
		$('.hide-address-inputs').on('click', function () {
			var activeEl = $(this).parents('.address-search-component-holder');
			activeEl.find('.type_b,.hide-address-inputs').show();
			activeEl.find('.input-wrapper:not(.custom-address), .hide-address-inputs').hide();
			activeEl.find('select.select2').val(null).trigger('change');
			activeEl.find('input[type="text"]').val('');
		});
	}
}
;

function sidebarSticky() {
	const submenu = document.querySelector('.submenu');
	const content = document.querySelector('.content');

	// Ensure both elements exist and that .submenu has a height
	if (!submenu || submenu.offsetHeight === 0 || !content) {
		return;
	}

	const submenuHeight = submenu.offsetHeight; // Get .submenu's height
	const contentHeight = content.offsetHeight; // Get .content's height
	const viewportHeight = window.innerHeight;  // Get viewport height

	// Check if .content height is greater than .submenu height
	if (contentHeight > submenuHeight) {
		const difference = viewportHeight - submenuHeight - 16; // Subtract .submenu height from viewport height and subtract 16

		// Only adjust the top if the difference is negative
		if (difference < 0) {
			const differenceAdjusted = difference - 16; // Add 16 to the negative difference
			submenu.style.top = `${differenceAdjusted}px`; // Set the calculated value as the 'top' style
		} else {
		}
	} else {
	}
}
window.addEventListener('resize', () => {
	sidebarSticky();
});

function langTabControl() {
	let $dropdown = $('.languages');

	$dropdown.on('focusin mouseenter', function () {
		$dropdown.addClass('open');
	});
	$dropdown.on('focusout mouseleave', function () {
		setTimeout(function () {
			if (!$dropdown.has(document.activeElement).length) {
				$dropdown.removeClass('open');
			}
		}, 1);
	});
}

function attrControl() {
	$('input[type="file"]').attr('aria-label', 'Formos laukas');
	$('.g-recaptcha-response').attr('aria-label', 'Google recaptcha laukas');

}
//
//window.validate = validate;